import React, { Fragment, Suspense, useEffect, useState } from "react";
import Preloader from "../../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { base_url } from "../Constants";
import axios from "axios";
import { useParams } from "react-router-dom";
const Breadcrumb = React.lazy(() => import("../../components/Breadcrumb"));
const OrderShow = React.lazy(()=>import("../../components/Profile/Show"))
const FooterBottomOne = React.lazy(() =>
  import("../../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../../components/NavbarOne"));
const SearchPopup = React.lazy(() => import("../../elements/SearchPopup"));
const Show = () => {
  const {t,i18n} =  useTranslation();
  const setting =  useSelector(state=>state.settingData.data);
  const  [item,setItem] =  useState({});
  const user =  JSON.parse(localStorage.getItem('authUser'));
  const  {id} = useParams();
  useEffect(()=>{
    let config = {
        headers: {
        'Authorization': 'Bearer ' + user.token,
        language:i18n.language
        }
    }; 
      
      axios.get(base_url+'/api/single-order/'+id,config).then(response=>{
           const res =  response.data;
            if (res.state == 1) {
                setItem(res.data);
            }
        })
  },[])
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Breadcrumb */}
          {setting&&<Breadcrumb header_bg={base_url+'/'+setting.order_bg} title={t('Order no')+' : '+item.no} />}
          

          {/* Breadcrumb */}
          {(setting&&item)&&<OrderShow item={item}/>} 
          
          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>
      </Fragment>
    </>
  );
};

export default Show;
